import { METHOD_API, createConnector, prefixApi } from "./Connector";

export const deleteBannerMessage = (data: any) => {
  return createConnector(
    METHOD_API.DELETE,
    `${prefixApi}/delete-banner-message`,
    data,
  );
};
